module.exports = __webpack_public_path__ + "static/media/201EE218 .6d77d9cd.jpg";